export default function Footer({
  children,
  height = '86px',
}: {
  children?: React.ReactNode;
  height?: string;
}) {
  return (
    <>
      <footer className="fixed bottom-0 left-0 right-0 w-full bg-gradient-to-b from-[#24242B] to-[#1D1D25] rounded-t-lg text-white">
        <div className="mx-auto pt-5 px-4 pb-5" style={{ height }}>
          {children}
        </div>
      </footer>
      <div className="pt-5 px-4 pb-5 w-full" style={{ height }}></div>
    </>
  );
}
